export const Constants = {
  GET_DATA: 'Global.GET_DATA',
  SET_DATA: 'Global.SET_TOKEN_ALIVE',
  GET_DATA_API: '/api/v1/users/check_token_alive'
}

export const getData = (formData) => {
  return {
    type: Constants.GET_DATA,
    payload: formData
  }
}

export const setTokenAlive = (isAlive) => {
  return {
    type: Constants.SET_DATA,
    payload: isAlive
  }
}


// WEBPACK FOOTER //
// ./src/containers/Full/actions.js